import React from 'react';
import ReviewSupplierPage from './ReviewSupplierPage';

// Wrapper component that reuses the supplier review page without the import button.
const ReviewSupplierMappingPage = () => (
  <ReviewSupplierPage
    showImportButton={false}
    createButtonLabel="Create Mapping"
    containerClassName="fullScreenContainer--mapping"
  />
);

export default ReviewSupplierMappingPage;
